<template>
  <div>
    <ul
        class="nav nav-tabs border-0 flex-column pl-0 justify-content-between"
        id="myTab"
        role="tablist"
    >
      <template v-if="reasons && reasons.length > 0">
        <li
            class="nav-item"
            v-for="(item, index) in reasons"
            :key="'reason-' + index"
            @click.prevent="[loadServices(item.id), selIndx = index]"
        >
          <a
              class="nav-link border-0 "
              :class="selIndx === index ? 'active' : ''"
              id="completeReplacement"
              data-toggle="tab"
              href="#completeReplacement-tab"
              role="tab"
              aria-controls="completeReplacement"
              aria-selected="true"
              :data-test-id="'completeReplacement'+index"
          >
            <img :src="'/' + item.image" width="85px" height="85px" />
            <span class="ml-2">{{ item.title }}</span>
          </a>
        </li>
      </template>
      <v-progress-circular
          v-else
          :size="70"
          :width="7"
          color="blue-grey lighten-4"
          indeterminate
          style="left: 50%; top: 50%; translate: -35px -35px;"
      />
    </ul>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
          selIndx: null,
        }
    },
    async mounted() {
      this.$store.commit("updateReasons", {});
      this.$store.dispatch('login/getWorkshop').then(() => {
        this.$store.dispatch("fetchReasons");
        this.$store.commit("clearServices");
      })
    },
    computed: {
        ...mapGetters(["reasons", "runflat", "frameVehicle"]),
        direction() {
          return this.$store.state.login.chosenDirection
        },
    },
    watch: {
      direction () {
        this.$store.commit("updateReasons", {});
        this.$store.dispatch("fetchReasons");
        this.selIndx = null
        this.$store.commit("setServicesLoad", false);
        this.$store.commit("setSelectedCalc", null);
      },
    },
    methods: {
        loadServices(reasonId) {
            this.$store.commit("setServicesLoad", false);
            this.$store.commit("setSelectedCalc", null);
            this.$store.dispatch("fetchServices", [
                reasonId,
                this.runflat,
                this.frameVehicle
            ]);
        },
    }
};
</script>
<style scoped>
#myTab {
    height: 65vh;
}
</style>
